import { render, staticRenderFns } from "./PartnerKeywordModal.vue?vue&type=template&id=0a355b0a&"
import script from "./PartnerKeywordModal.vue?vue&type=script&lang=js&"
export * from "./PartnerKeywordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports